<template>
    <div>
        <autoDesktop v-if="isDesktop()"></autoDesktop>
        <autoMobile  v-if="isMobile()"></autoMobile>
    </div>
</template>

<script>
    import autoMobile from "../DevisAuto/flotte.auto.mobile.vue"
    import autoDesktop from "../DevisAuto/flotte.auto.desktop.vue"

    export default {
        name: 'AutoIndex',
        components: {
            autoMobile,
            autoDesktop
        },
        data() {
            return {
                
            }
        },

        methods: {
            isMobile: function () {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },
  
            isDesktop: function () {
                if (screen.width > 768) {
                    return true
                } else {
                    return false
                }
            },
             showFlotteAccess(){
            // Check if user is logged in AND if user's gender is 'entreprise'
            let disabledAccessFlotte = this.$store.state.isUserLoggedIn &&  this.$store.state.user &&  this.$store.state.user.sexe === 'entreprise';
            if(disabledAccessFlotte != true){
                this.$router.push('/')
            }
        },
        },
        mounted() {
            this.showFlotteAccess()
        }
    }
</script>